import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class Vehicle extends BaseModel {
    @Expose() license = "";
    @Expose() policyId = -1;
    @Expose() brand = "";
    @Expose() model = "";
    @Expose() category = "";
    @Expose() manufactureYear = -1;
    @Expose() chasis = "";
    @Expose() engine = "";
    @Expose() usage = "";
    @Expose() insuredAmount = -1;
    @Expose() gps = false;
}
